<template>
	<div style="background: #f5f5f5; min-height: 100vh">
		<brieHeader />
		<crumbs :crumFlag="true" bTxt="重选身份" />
		<div class="regBox">
			<div class="regtop">
				<img src="@/assets/img/laos.png" alt="" />
				<div class="regRig">
					<h2>注册老师账户</h2>
					<p>请根据表单填写以下信息, 完成注册!</p>
				</div>
			</div>
			<el-row style="padding: 0 50px">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demoRuleForm">
					<el-col :span="8">
						<el-form-item label="注册账户" prop="phone">
							<el-input v-model.number="ruleForm.phone" placeholder="请输入手机号" maxlength="11"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="所属省市" prop="areaId">
							<el-cascader
								clearable
								style="width: 100%"
								v-model="ruleForm.areaId"
								:options="cityJson"
								@change="changeFn"
								:props="{ value: 'value', label: 'label', children: 'children', emitPath: true, checkStrictly: true }"
							></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="学校" prop="school">
							<el-select
								ref="select"
								clearable
								style="width: 100%"
								@visible-change="handleVisibleChange"
								remote
								:remote-method="remoteSearchSchool"
								v-model="ruleForm.school"
								filterable
								default-first-option
								placeholder="请选择学校"
							>
								<el-option label="-1" value="-1">
									<div class="selBox" @click.stop="">
										<div class="selBtns" @click="scFlag = true" v-if="!scFlag">
											<img src="@/assets/img/cj.svg" alt="" class="icon" />
											创建
										</div>
										<div class="selInput" v-if="scFlag">
											<input class="inputs" placeholder="请输入内容" v-model="scVal" />
											<div @click="scQrBtn">确认</div>
											<div class="btnqx" @click="scQxBtn">取消</div>
										</div>
									</div>
								</el-option>
								<el-option v-for="item in schoolOptions" :key="item.id" :label="item.name" :value="item.name"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="姓名" prop="nickName">
							<el-input placeholder="请输入姓名" v-model="ruleForm.nickName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="证书编号" prop="certificateNumber">
							<el-input autocomplete="new-password" placeholder="请输入证书编号" v-model="ruleForm.certificateNumber"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="资格证书照片" class="upBoxs" prop="certificateUrl">
							<el-upload
								class="avatar-uploader"
								:action="upHttpUrl"
								:before-upload="befUpfn"
								:http-request="uploadImage"
								:show-file-list="false"
								:on-success="handleAvatarSuccess"
							>
								<div class="upBox">
									<img v-if="ruleForm.certificateUrl" :src="localImg" class="avatar" />
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</div>
							</el-upload>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="输入密码" prop="password">
							<el-input autocomplete="new-password" placeholder="采用6-18位字母数字符号组合" v-model="ruleForm.password" show-password></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="确认密码" prop="passwordc">
							<el-input placeholder="采用6-18位字母数字符号组合" v-model="ruleForm.passwordc" show-password></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8" class="sjBox">
						<el-form-item label="图形验证码" prop="code">
							<div class="logTx">
								<el-input v-model="ruleForm.code" placeholder="请输入图形验证码">
									<i slot="prefix" style="display: flex; align-items: center; height: 40px">
										<img class="header-icon" src="@/assets/img/yzm.png" alt="" />
									</i>
								</el-input>
								<button @click="txyzBtn" class="twBtn btnS" v-preventReclick>
									<div>
										<img :src="yzImg" alt="" />
									</div>
								</button>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8" class="sjBox">
						<el-form-item prop="smsCode" label="手机验证">
							<el-input v-model="ruleForm.smsCode" placeholder="请输入短信验证码" :maxlength="6">
								<i slot="suffix">
									<div class="yymBox">
										<span class="hqyym supHove3" v-show="yymStatus == 0" @click="hqBtn">获取验证码</span>
										<div class="hqTime">
											<p v-show="yymStatus == 1">
												<span style="margin-right: 4px">{{ nums }}s</span>
												后重新发送
											</p>
											<span v-show="yymStatus == 2" class="hqyym" @click="hqBtn">重新获取验证码</span>
										</div>
									</div>
								</i>
							</el-input>
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<div class="regFot">
							<div class="regBtn supHove3" @click="bdfBtn">取消</div>
							<div class="regBtn active supHove3" @click="zcBtn">确认注册</div>
						</div>
					</el-col>
				</el-form>
			</el-row>
		</div>
		<loginFoot />
	</div>
</template>

<script>
import loginFoot from '@/components/foot/loginFoot';
import crumbs from '@/components/hearder/crumbs';
import brieHeader from '@/components/hearder/brieHeader';

export default {
	name: 'regB',
	data() {
		var codeChecked = (rule, value, callback) => {
			if (this.isGuoqi) {
				return callback(new Error('请轻微点击验证码刷新'));
			} else if (this.ruleForm.code) {
				callback();
			} else {
				return callback(new Error('请输入图形验证码'));
			}
		};
		return {
			isGuoqi: false,
			a: ['重选身份'],
			cityJson: [],
			schoolOptions: [],
			localImg: '',
			upHttpUrl: '',
			upHttpKey: '',
			ruleForm: {
				accountType: '0', // 0老师 1学生
				nickName: '',
				code: '',
				school: '',
				areaId: '',
				certificateNumber: '',
				certificateUrl: '',
				password: '',
				passwordc: '',
				phone: '',
				smsCode: '',
				uuid: ''
			},
			scVal: '',
			scFlag: false,
			setInFn: '',
			nums: 60,
			yymStatus: 0, // 0未获取 1获取中 2重新获取
			rules: {
				phone: [{ required: true, validator: this.checkAge, trigger: 'blur' }],
				nickName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				code: [
					// { required: true, message: '请输入图形验证码', trigger: 'blur' },
					{
						required: true,
						// message: '请选择充值金额',
						trigger: 'blur',
						validator: codeChecked
					}
				],
				certificateNumber: [
					// { required: true, message: '请输入教师资格证编号', trigger: 'blur' },
					{ required: true, validator: this.checkCertificateNumber, trigger: 'blur' }
				],
				certificateUrl: [{ required: true, message: '请上传教师资格证照片', trigger: 'blur' }],
				password: [
					// { pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*()<>,.?-_+=`~])[0-9a-zA-Z!@#$%^&*()<>,.?-_+=`~]{6,18}$/, message: '密码请采用6-18位字母数字符号组合', trigger: 'blur' },
					{ required: true, validator: this.validatePass, trigger: 'blur' }
				],
				passwordc: [{ required: true, validator: this.validatePass2, trigger: 'blur' }],
				school: [{ required: true, message: '请选择学校', trigger: 'change' }],
				areaId: [{ required: true, message: '请选择省市', trigger: 'change' }],
				smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
			},
			wjName: '',
			regFlag: 0,
			yzImg: ''
		};
	},
	components: {
		brieHeader,
		loginFoot,
		crumbs
	},
	methods: {
		async checkCertificateNumber(rule, value, callback) {
			if (!value) {
				return callback(new Error('请输入教师资格证编号'));
			}
			await this.$http
				.get('api/app/user/checkCertificate', {
					params: {
						certificateNumber: value
					}
				})
				.then((res) => {
					if (res.data == 1) {
						return callback(new Error('教师资格证编号已注册'));
					}
					console.log(res);
				});
		},
		async checkAge(rule, value, callback) {
			if (!value) {
				return callback(new Error('请输入手机号码'));
			}
			if (!(value + '').match(/^1[1-9]\d{9}$/)) {
				return callback(new Error('手机号码格式不正确'));
			}
			await this.$http
				.get('api/app/user/checkPhone', {
					params: {
						phone: value
					}
				})
				.then((res) => {
					if (res.data == 1) {
						return callback(new Error(res.msg));
					}
					console.log(res);
				});
		},
		uploadImage(file) {
			// 这里的`file`参数是要上传的文件对象
			// 在这里根据需要添加一些逻辑，如显示进度条
			const xhr = new XMLHttpRequest();
			//element-ui默认使用post提交，但是我们生成的url需要使用 put 提交
			//需要指定 put 直传，以及this.upHttpUrl（后端返回的url）
			xhr.open('PUT', this.upHttpUrl, true);
			//设置上传文件的类型
			xhr.setRequestHeader('Content-Type', file.file.type); // 或者 file.type
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						//进入到这里就表明上传成功了
						//我这里对后端返回的url进行截取方便存入数据库，因为前端还需要展示图片
						let indexOf = this.upHttpUrl.indexOf('?');
						console.log(this.upHttpUrl.slice(0, indexOf), xhr.response, 55555);
						this.$http
							.post('api/app/common/upFileAttachment', {
								key: this.upHttpKey,
								originalFileName: this.wjName
							})
							.then((red) => {
								this.ruleForm.certificateUrl = red.data.attDir;
								this.localImg = this.$imgUrl + red.data.attDir;
								console.log(red);
							});
					} else {
					}
				}
			};
			//发送
			xhr.send(file.file); //或者 file
		},
		changeFn(e) {
			console.log(e, 9999);
			this.$http
				.post('api/app/yydSchool/list', {
					areaList: e
				})
				.then((res) => {
					console.log(res);
					this.ruleForm.school = '';
					this.schoolOptions = res.rows;
				});
		},
		async befUpfn(e) {
			console.log(e, 7777);
			this.wjName = e.name;
			await this.$http
				.get('api/app/common/getToken', {
					params: {
						fileName: e.name
					}
				})
				.then((res) => {
					console.log(9999);
					this.upHttpUrl = res.data.host;
					this.upHttpKey = res.data.key;
				});
		},
		handleVisibleChange(visible) {
			if (!visible) {
				// 选项菜单被关闭时的操作
				this.scFlag = false;
				this.scVal = '';
			}
		},
		bdfBtn() {
			this.$router.back();
		},
		scQrBtn() {
			console.log(this.scVal);
			if (this.scVal) {
				this.$http
					.post('api/app/yydSchool', {
						name: this.scVal,
						areaList: this.ruleForm.areaId || []
					})
					.then((res) => {
						if (res.code == 200) {
							this.ruleForm.school = this.scVal;
							this.schoolOptions.push({
								id: this.$uuid(),
								name: this.scVal
							});
							this.$refs.select.visible = false;
						}
					});
			}
		},
		scQxBtn() {
			this.scFlag = false;
			this.scVal = '';
		},
		zcBtn() {
			this.$refs['ruleForm'].validate((valid) => {
				// if (true) {
				if (valid) {
					console.log(this.ruleForm, 999);
					let { areaId, ...datas } = this.ruleForm;
					let set = this.$loading(this.$pre);
					this.$http
						.post('api/app/login/register', {
							areaId: areaId[areaId.length - 1],
							...datas
						})
						.then((res) => {
							set.close();
							if (res.code == 200) {
								// localStorage.setItem('token',res.data.token)
								// this.$store.commit('setInfoData',res.data)
								this.$message({
									message: '提交成功，请等待审核',
									type: 'success'
								});
								setTimeout(() => {
									this.$router.push({
										path: 'login'
									});
								}, 1500);
							} else if (res.code == 500) {
								if (res.msg == '验证码已过期') {
									this.isGuoqi = true;
									this.$refs['ruleForm'].validateField(['code']);
								}
							}
						});
				}
			});
		},
		// 远程搜索学校
		remoteSearchSchool(query) {
			if (!query) {
				this.schoolOptions = [];
				return;
			}
			// 调用搜索接口
			this.$http
				.post('api/app/yydSchool/list', {
					name: query // 根据实际接口参数调整
				})
				.then((res) => {
					this.schoolOptions = res.rows || [];
				})
				.catch(() => {});
		},
		handleAvatarSuccess(res, file) {
			this.ruleForm.certificateUrl = res.data.url;
			this.localImg = URL.createObjectURL(file.raw);
		},
		txyzBtn() {
			this.$http.get('api/captchaImage').then((res) => {
				this.ruleForm.uuid = res.uuid;
				this.yzImg = res.img;
				if (this.isGuoqi) {
					this.isGuoqi = false;
					this.$refs['ruleForm'].validateField(['code']);
				}
				this.isGuoqi = false;
			});
		},
		init() {
			this.txyzBtn();
			this.$http.get('api/maintain/area/areaCascaderList').then((res) => {
				console.log(res);
				this.cityJson = res.data;
			});
			this.$http
				.post('api/app/yydSchool/list?pageNum=1&pageSize=1000', {
					areaList: []
				})
				.then((res) => {
					console.log(res);
					this.schoolOptions = res.rows;
				});
		},
		hqBtn() {
			if (!/^1[1-9]\d{9}$/.test(this.ruleForm.phone)) {
				this.$message.error('请输入正确的手机号');
				return;
			}
			if (!this.ruleForm.code) {
				this.$message.error('请输入图形验证码');
				return;
			}
			this.$http
				.post('api/app/login/sendCode', {
					phone: this.ruleForm.phone,
					code: this.ruleForm.code,
					uuid: this.ruleForm.uuid
				})
				.then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '发送成功',
							type: 'success'
						});
						this.yymStatus = 1;
						this.setInFn = setInterval(() => {
							if (this.nums == 0) {
								this.yymStatus = 2;
								this.nums = 60;
								clearInterval(this.setInFn);
								return;
							}
							this.nums--;
						}, 1000);
					} else if (res.code == 500) {
						if (res.msg == '验证码已过期') {
							this.isGuoqi = true;
							this.$refs['ruleForm'].validateField(['code']);
						}
					}
				});
		},
		validatePass(rule, value, callback) {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.ruleForm.passwordc !== '') {
					this.$refs.ruleForm.validateField('passwordc');
				}
				// 验证规则
				const hasMinLength = value.length >= 6;
				const hasMaxLength = value.length <= 18;
				const hasLetter = /[a-zA-Z]/.test(value);
				const hasNumber = /\d/.test(value);
				const hasSymbol = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value);
				if (hasMinLength && hasMaxLength && hasLetter && hasNumber && hasSymbol) {
					callback();
				} else {
					callback(new Error('密码请采用6-18位字母数字符号组合'));
				}
			}
		},
		validatePass2(rule, value, callback) {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.logTx {
	display: flex;
	height: 50px;
	.twBtn {
		width: 64px;
		height: 40px;
		margin-left: 10px;
		cursor: pointer;
		img {
			width: 64px;
			height: 40px;
		}
	}
}
.regBox {
	width: 1200px;
	margin: 0 auto 50px;
	background: #fff;
	box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.17);
	border-radius: 6px;
	padding: 32px 13px 57px;
	box-sizing: border-box;

	.regtop {
		display: flex;
		margin-bottom: 31px;
		img {
			width: 67px;
			height: 67px;
			margin-right: 20px;
		}

		.regRig {
			h2 {
				color: #000000;
				font-size: 22px;
				margin: 9px 0;
			}

			p {
				font-size: 12px;
				color: #999a9c;
			}
		}
	}
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	height: 40px;
}

.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}

.upBox {
	height: 30px;
	position: relative;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 134px;
	height: 96px;
	background: #d9d9d9;
	border-radius: 8px;
	line-height: 96px;
	text-align: center;
	position: absolute;
	left: 0;
	top: 0;
}

.avatar {
	width: 134px;
	height: 96px;
	display: block;
	position: absolute;
	border-radius: 6px;
	left: 0;
	top: 0;
}

.yymBox {
	font-size: 12px;

	span {
		color: #1d7b3a;
	}

	.hqyym {
		cursor: pointer;
	}
}

.regFot {
	display: flex;
	justify-content: center;

	.regBtn {
		width: 88px;
		height: 40px;
		margin-right: 25px;
		background: #ffffff;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		border: 1px solid #d8e0f0;
		color: #000000;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		font-size: 16px;
		cursor: pointer;

		&:last-of-type {
			margin-right: 0;
		}
	}

	.active {
		background: #1d7b3a;
		color: #ffffff;
		border: 1px solid #1d7b3a;
	}
}
.sjBox {
	margin-right: 1px;
}
.selBox {
	width: calc(100% + 40px);
	position: relative;
	left: -20px;
	box-sizing: border-box;
	color: #1d7b3a;
	.selBtns {
		position: relative;
		left: 20px;
	}
	.icon {
		width: 10px;
		height: 10px;
	}
	.selInput {
		position: relative;
		left: 20px;
		display: flex;
		.inputs {
			background: transparent;
			width: 160px;
			color: #606266;
		}
		div {
			margin-right: 4px;
			position: relative;
			right: -12px;
			font-size: 13px;
		}
		.btnqx {
			color: #999a9c;
		}
	}
}
</style>
